export type RelabelPrintSize = "A6" | "A4";

interface RelabelPage {
  data: Array<{ pdSttNo: string }>;
  pagination: { totalData?: number };
}

export function relabelPrintLimit(value: number): number {
  return Number.isFinite(value) && value > 0 ? Math.floor(value) : 500;
}

export function assertRelabelPrintLimit(total: number, cap: number): void {
  if (!Number.isFinite(total) || total < 0)
    throw new Error("Total data Relabel tidak valid.");
  if (total > cap)
    throw new Error(`Maksimal ${cap} STT untuk Print semua resi.`);
}

export async function collectRelabelStts(
  getPage: (page: number) => Promise<RelabelPage>,
  cap: number
): Promise<string[]> {
  const stts = new Set<string>();
  let processedRows = 0;
  for (let page = 1; ; page++) {
    const result = await getPage(page);
    const total = result.pagination.totalData;
    if (typeof total !== "number")
      throw new Error("Total data Relabel tidak tersedia.");
    assertRelabelPrintLimit(total, cap);
    if (!result.data.length && processedRows < total)
      throw new Error("Data Relabel berubah. Silakan coba lagi.");
    result.data.forEach((row) => {
      if (!row.pdSttNo) throw new Error("Nomor STT Relabel tidak tersedia.");
      stts.add(row.pdSttNo);
    });
    processedRows += result.data.length;
    assertRelabelPrintLimit(processedRows, cap);
    if (processedRows >= total) return Array.from(stts);
  }
}

export async function loadRelabelPrintData<T>(
  stts: string[],
  getPrint: (sttNo: string) => Promise<T>
): Promise<{ successful: T[]; failed: string[] }> {
  const successful: T[] = [];
  const failed: string[] = [];
  for (const sttNo of stts) {
    try {
      successful.push(await getPrint(sttNo));
    } catch {
      failed.push(sttNo);
    }
  }
  return { successful, failed };
}
